import { MRT_ColumnDef } from "material-react-table"
import { useMemo, useState } from "react"
import { Button, Chip } from "@mui/material";
import CheckBoxIcon from '@mui/icons-material/CheckBox';

interface UseTableColumnsConsultasPorTipoProps {
    pagination?: { pageIndex: number; pageSize: number };
}

export const useTableColumnsConsultasPorTipo = (props?: UseTableColumnsConsultasPorTipoProps) => {
    const { pagination } = props || {};

    const [dataPuerto, setDataPuerto] = useState([]);
    const [openActividadesModal, setOpenActividadesModal] = useState(false);
    const ckeck = (row: any) => {
        setDataPuerto(row.original);
        setOpenActividadesModal(true)
    }

    const columnBase = useMemo<MRT_ColumnDef<any>[]>(() => [
        {
            header: 'LIBERAR PUERTO',
            size: 100,
            Cell: ({ row }) => {
                let statusCheck = false;
                let textCheck = '';
                switch (row.original.nombre_estado_puerto) {
                    case 'LIBERADO':
                        statusCheck = true;
                        textCheck = 'Liberado ' + row.original.fecha_puerto_liberado;
                        break;
                    case 'OCUPADO':
                        statusCheck = true;
                        textCheck = 'No disponible';
                        break;
                    default:
                        statusCheck = false;
                        textCheck = 'Liberar';
                        break;
                }
                return (
                    <>
                        <div style={{ textAlign: 'center' }}>
                            <Button variant="outlined" color="success" onClick={() => ckeck(row)} disabled={statusCheck}><CheckBoxIcon /></Button>
                            <br></br>
                            {textCheck}
                        </div>
                    </>
                )
            },
        },
        {
            accessorKey: 'numero_puerto',
            header: 'NÚMERO DE PUERTO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombre_estado_puerto',
            header: 'ESTADO PUERTO',
            size: 100,
            Cell: ({ cell }) => {
                let estado_puerto = cell.getValue<string>();
                return (
                    <Chip label={estado_puerto || '-'} variant="filled" color={estado_puerto == "OCUPADO" ? 'success' : (estado_puerto == "POR LIBERAR" ? 'warning' : 'error')} />
                )
            }
        },
        {
            accessorKey: 'nombre_estado_servicio',
            header: 'ESTADO SERVICIO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombre_cliente',
            header: 'NOMBRE CLIENTE',
            size: 200,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombre_cliente_anterior',
            header: 'CLIENTE ANTERIOR (Cambio Razon Social)',
            size: 200,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'fecha_cambio_estado',
            header: 'FECHA CAMBIO ESTADO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'usuario_cambio_estado',
            header: 'USUARIO CAMBIO ESTADO',
            size: 150,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'direccion_ip',
            header: 'DIRECCION IP',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'sector',
            header: 'SECTOR',
            size: 200,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombre_tipo_plan',
            header: 'TIPO PLAN',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombre_plan',
            header: 'NOMBRE PLAN',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'olt',
            header: 'OLT',
            size: 200,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'usuario_puerto_liberado',
            header: 'USUARIO ULTIMA MODIFICACIÓN',
            size: 200,
            Cell: ({ row }) => {
                let usuario = row.original.username_libera_puerto || row.original.usuario_puerto_liberado;
                return usuario || '-';
            },
        },
    ], [pagination]);

    return {
        columnBase,
        dataPuerto,
        openActividadesModal,
        setOpenActividadesModal,
    }
}
